import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';


import * as _ from 'lodash';
import { EndpointFactory } from "./endpoint-factory.service";
import { HttpClient } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";


@Injectable()
export class DependentService extends EndpointFactory  {


    private _baseURl = "";


    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    getDependentsAdmin(memberId: string): Observable<any> {
        return this
            .http.get(this._baseURl + `api/dependent/get-dependents-admin/${memberId}`, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }

    getDpendentEventLogs(dependentId: string): Observable<any> {
        return this
            .http.get(this._baseURl + `api/dependent/get-dependent-logs/${dependentId}`, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }

    dependentPreRegister(dependentId : string, productId : number) {
        return this.http.post(this._baseURl + `api/dependent/pre-register/${dependentId}/${productId}`, {}, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }

    updateDependentElig(dependentId: string) {
        return this.http.post(this._baseURl + `api/dependent/update-dependent-elig/${dependentId}`, {}, this.getRequestHeaders())
            .catch (err => this.handleError(err, null))
    }

    updatePassword(data) {
        return this.http.put(this._baseURl + `api/dependent/change-password`, data, this.getRequestHeaders())
            .catch(err => this.handleError(err, null))
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/dependent.service.ts